angular.module('qkr').controller('OptionSetController', ($scope, $rootScope, $uibModal, $routeSegment, merchantService,
                                                         inventoryService, messageService, utils, appConfig,
                                                         gettextCatalog, $log) => {
    $scope.$routeSegment = $routeSegment;    // Used to know what we've
    // Selected
    $scope.saving = false;
    $scope.orderProp = '-dateCreated';    // Default order
    $scope.isOpenOptionSet = false;
    $scope.requiresReload = false;
    $scope.optionSets = [];
    $scope.optionSetsLoaded = false;
    $scope.allowEditOnOutletLevel = merchantService.behaviour(merchantService.merchantInfo,
        'inventoryPage.allowEditOnOutletLevel');
    $scope.isCharityOptionSet = merchantService.behaviour(merchantService.merchantInfo,
        'optionSetPage.charityOptionSet');
    $scope.isEditable = (appConfig.isElevatedUser && (!appConfig.outletLevel || $scope.allowEditOnOutletLevel)) &&
        merchantService.behaviour($rootScope.merchantInfo, 'optionSetPage.allowEdit') || appConfig.isDepartmentManager;
    $scope.outletLevel = appConfig.outletLevel;
    $scope.disableExpression = merchantService.behaviour(merchantService.merchantInfo,
        'optionSetPage.disableEditOnOutletLevel');

    $scope.init = function() {
        $scope.$routeSegment = $routeSegment;    // Used to know what we've selected
        $scope.optionSetsLoaded = false;
        $scope.query = '';
        loadOptionSets();
        if (!utils.hasNoValue($rootScope.merchantInfo)) {
            $scope.baseImgUrl = $rootScope.merchantInfo.baseImageUrl;
        }
    };

    // The user selects a category
    $scope.selectOptionSet = function() {
        $scope.isOpenOptionSet = true;
    };

    // Add an Option Set button pressed
    $scope.addOptionSet = function() {
        const p = {currency: $rootScope.defaultCurrency};
        const optionSet = angular.copy(p);

        const modalInstance = $uibModal.open({
            template: require('../templates/inventory/optionSet.html'),
            controller: 'OptionSetEditController',
            windowClass: 'fade',
            backdrop: 'static',
            resolve: {
                optionSet() {
                    return null;
                },
                optionSetAction() {
                    return 'create';
                },
                optionSetList() {
                    return $scope.optionSets;
                }
            }
        });

        modalInstance.result
            .then((selectedItem) => {
                loadOptionSets();
            }).catch($log.error);
    };

    // Add an Option Set button pressed
    $scope.editOptionSet = function(optionSet) {
        const modalInstance = $uibModal.open({
            template: require('../templates/inventory/optionSet.html'),
            controller: 'OptionSetEditController',
            windowClass: 'fade',
            backdrop: 'static',
            resolve: {
                optionSet() {
                    return angular.copy(optionSet);
                },
                optionSetAction() {
                    return 'edit';
                },
                optionSetList() {
                    return $scope.optionSets;
                }
            }
        });

        modalInstance.result
            .then((res) => {
                if (res !== 'cancel') {
                    loadOptionSets();
                }
            }).catch($log.error);
    };

    // Add an Option Set button pressed
    $scope.cloneOptionSet = function(optionSet) {
        const modalInstance = $uibModal.open({
            template: require('../templates/inventory/optionSet.html'),
            controller: 'OptionSetEditController',
            windowClass: 'fade',
            backdrop: 'static',
            resolve: {
                optionSet() {
                    return angular.copy(optionSet);
                },
                optionSetAction() {
                    return 'clone';
                },
                optionSetList() {
                    return $scope.optionSets;
                }
            }
        });

        modalInstance.result
            .then(() => {
                loadOptionSets();
            }).catch($log.error);
    };

    // Disable or enable an option set by clicking the button in the list
    $scope.disableOrEnableOptionSet = function(optionSet) {
        const request = angular.copy(optionSet);
        request.hidden = !optionSet.hidden;

        inventoryService.findMenuItemsUsingOptionSet(optionSet.id).then((promise) => {
            const listOfMenuItems = promise;
            const multiMsgArray = [];
            if (!utils.hasNoValue(listOfMenuItems)) {
                const action = optionSet.hidden ? gettextCatalog.getString('show') : gettextCatalog.getString('hide');
                const extra = optionSet.hidden ? '' : gettextCatalog.getString('It will no longer be available ' +
                    'on Qkr!');
                let confMsg = gettextCatalog.getString('Are you sure you want to') + ' ' + action
                    + ' \'' + optionSet.name + '\'? ' + extra;
                if (!utils.hasNoValue(listOfMenuItems)) {
                    confMsg = gettextCatalog.getString('Are you sure you want to') + ' ' + action
                        + ' \'' + optionSet.name + '\'? ' + extra
                        + gettextCatalog.getString('This will affect the menu:')
                        + utils.summarizeListWithMenuNames(listOfMenuItems, 2) + '\'';
                    if (listOfMenuItems.length > 1)
                        confMsg = gettextCatalog.getString('Are you sure you want to') + ' ' + action
                            + ' \'' + optionSet.name + '\'? ' + extra
                            + gettextCatalog.getString('This will affect the menus:')
                            + utils.summarizeListWithMenuNames(listOfMenuItems, 2) + ' \'';
                }

                if (!optionSet.hidden) {
                    multiMsgArray.push(gettextCatalog.getString('To unhide an Option Set, click on the ' +
                        'down arrow to the right of the edit button and select \'Show\'.'));
                }

                const modalInstance = createCommonDialogModalInstance(
                    gettextCatalog.getString('Set') + action + ' ' + gettextCatalog.getString('to')
                    + ' ' + optionSet.name + ' ' + gettextCatalog.getString('option'),
                    gettextCatalog.getString('Confirm'),
                    confMsg,
                    multiMsgArray
                );

                modalInstance.result
                    .then((result) => {
                        if (result === 'ok') {
                            $scope.updateOptionSet(request);
                        }
                    }).catch($log.error);
            } else {
                $scope.updateOptionSet(request);
            }
        }).catch($log.error);
    };

    $scope.updateOptionSet = function(request) {
        inventoryService.updateOptionSet(request)
            .then(() => {
                messageService.saveAlert();
                loadOptionSets();
            }).catch($log.error);
    };

    // Delete an option set - requires confirmation if any menuItem is using the
    // Option set (note. NOT inventory item)
    $scope.deleteOptionSet = function(optionSet) {
        inventoryService.findMenuItemsUsingOptionSet(optionSet.id).then((promise) => {
            const listOfMenuItems = promise;

            let confMsg = gettextCatalog.getString('Are you sure you want to delete') + '\''
                + optionSet.name + '\'?' + gettextCatalog.getString('It will no longer be available on Qkr!');
            if (!utils.hasNoValue(listOfMenuItems)) {
                confMsg = gettextCatalog.getString('Are you sure you want to delete') + '\''
                    + optionSet.name + '\'?' + gettextCatalog.getString('It will no longer be available on Qkr!. ' +
                        'This will affect the menu:') + '\''
                    + utils.summarizeListWithMenuNames(listOfMenuItems, 2) + '\'';
                if (listOfMenuItems.length > 1)
                    confMsg = gettextCatalog.getString('Are you sure you want to delete') + '\''
                        + optionSet.name + '\'?'
                        + gettextCatalog.getString('It will no longer be available on Qkr!. ' +
                            'This will affect the following menus:') + '\''
                        + utils.summarizeListWithMenuNames(listOfMenuItems, 2) + '\'';
            }

            const modalInstance = createCommonDialogModalInstance(
                gettextCatalog.getString('Delete') + ' ' + optionSet.name + ' ' + gettextCatalog.getString('option'),
                gettextCatalog.getString('Delete'),
                confMsg,
                []
            );

            modalInstance.result
                .then((result) => {
                    if (result === 'ok') {
                        deleteOptionSet(optionSet.id);
                    }
                }).catch($log.error);
        }).catch($log.error);
    };

    $scope.showCreateFirstOptionSet = function() {
        // If there are no option sets, show the Create First Option Set div on the outlet page for
        // schools and merchant page for non-schools
        const showForOutlet =
            merchantService.behaviour(merchantService.merchantInfo, 'optionSetPage.showCreateFirstOptionSet');
        // == School
        const noOptionSets = $scope.optionSets.length === 0;
        const outletLevel = $scope.outletLevel;

        return (showForOutlet && outletLevel && noOptionSets) || (!outletLevel && noOptionSets);
    };

    const deleteOptionSet = function(id) {
        inventoryService.deleteOptionSet(id).then(() => {
            messageService.saveAlert(gettextCatalog.getString('Option Set was successfully deleted'));
            // Reload the dashboard info
            $rootScope.$broadcast('reloadDashboard');
            loadOptionSets();
        }, (promise) => {
        }).catch($log.error);
    };

    $scope.showCreateFirstOptionSet = function() {
        // If there are no option sets, show the Create First Option Set div on the
        // outlet page for schools and merchant page for non-schools
        const showForOutlet = merchantService.behaviour(merchantService.merchantInfo,
            'optionSetPage.showCreateFirstOptionSet'); // == School
        const noOptionSets = $scope.optionSets.length == 0;
        const outletLevel = $scope.outletLevel;

        return (showForOutlet && outletLevel && noOptionSets) || (!outletLevel && noOptionSets);
    };

    const loadOptionSets = function() {
        $scope.optionSetsLoaded = false;
        $scope.optionSets = [];

        inventoryService.loadOptionSets()
            .then((promise) => {
                $scope.optionSets = promise;
            })
            .finally(() => {
                $scope.optionSetsLoaded = true;
            })
            .catch($log.error);
    };

    const createCommonDialogModalInstance = function(title, confirmButtonName, confirmMsg, multiMsgArray) {
        const modalInstance = $uibModal.open({
            template: require('../templates/common/modalDialog.html'),
            controller: 'commonModalDialogController',
            windowClass: 'fade',
            backdrop: 'static',
            resolve: {
                title() {
                    return title;
                },
                confirmButtonName() {
                    return confirmButtonName;
                },
                confirmMsg() {
                    return confirmMsg;
                },
                multiMsgArray() {
                    return multiMsgArray;
                }
            }
        });

        return modalInstance;
    };
});



// WEBPACK FOOTER //
// ./src/controllers/optionset.controller.js